// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3gdeL","calendarButtons":"ClockData_calendarButtons__1XPZR"};